<template>
  <!-- Start Cloud Hosting Services -->
  <section class="services-area ptb-80 bg-f7fafd">
    <div class="container">
      <div class="row h-100 justify-content-center align-items-center">
        <div class="col-lg-6 col-md-12 services-content">
          <div class="section-title">
            <h2>Cours et formations en Systemes et réseaux informatiques</h2>
            <div class="bar"></div>
            <p>
              Le département Réseaux et Systèmes forme des étudiants capables de
              concevoir, de paramétrer, de sécuriser et d’administrer des
              réseaux de données de type IP utilisant les technologies LAN, WAN
              et WLAN. Il fournit aux entreprises, aux opérateurs et autres, des
              ingénieurs, des techniciens et spécialistes capables de mobiliser
              et d’intégrer des solutions adéquates et des technologies
              appropriées et pertinentes pour résoudre des problèmes relevant
              des domaines des réseaux d’entreprises vers les technologies de
              virtualisation de réseaux et de serveurs et la mutualisation de
              services à travers le Cloud Computing.
            </p>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="share-2"></vue-feather> Réseaux de base, les
                fondamentaux
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="globe"></vue-feather> Réseaux avancées
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="cpu"></vue-feather> GNS3: maitriser l'émulation des
                résaux
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="shield"></vue-feather> Securité Informatique
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="layout"></vue-feather> Installation et configuration
                de windows 7, 8, 10 et 11
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="server"></vue-feather> Administration Système Windows
                Server (2008, 2012, 2016)
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="layout"></vue-feather> Administration Système Linux
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="box">
                <vue-feather type="file-text"></vue-feather> Bureautique (Word, Excel,
                Access, PowerPoint etc.…)
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12 services-right-image">
          <img src="../../assets/img/services-right-image/book-self.png" class="wow fadeInDown" alt="book-self" />
          <img src="../../assets/img/services-right-image/box.png" class="wow fadeInUp" alt="box" />
          <img src="../../assets/img/services-right-image/chair.png" class="wow fadeInLeft" alt="chair" />
          <img src="../../assets/img/services-right-image/cloud.png" class="wow zoomIn" alt="cloud" />
          <img src="../../assets/img/services-right-image/cup.png" class="wow bounceIn" alt="cup" />
          <img src="../../assets/img/services-right-image/flower-top.png" class="wow fadeInDown" alt="flower" />
          <img src="../../assets/img/services-right-image/head-phone.png" class="wow zoomIn" alt="head-phone" />
          <img src="../../assets/img/services-right-image/monitor.png" class="wow fadeInUp" alt="monitor" />
          <img src="../../assets/img/services-right-image/mug.png" class="wow rotateIn" alt="mug" />
          <img src="../../assets/img/services-right-image/table.png" class="wow fadeInUp" alt="table" />
          <img src="../../assets/img/services-right-image/tissue.png" class="wow zoomIn" alt="tissue" />
          <img src="../../assets/img/services-right-image/water-bottle.png" class="wow zoomIn" alt="water-bottle" />
          <img src="../../assets/img/services-right-image/wifi.png" class="wow fadeInLeft" alt="wifi" />
          <img src="../../assets/img/services-right-image/cercle-shape.png" class="bg-image rotateme" alt="IT+ formation cours informatique djibouti" />

          <img src="../../assets/img/services-right-image/main-pic.png" class="wow fadeInUp" alt="main-pic" />
        </div>
      </div>
    </div>
  </section>
  <!-- End Cloud Hosting Services -->
</template>
